(function(){
  if(window.__lpBP)return;window.__lpBP=1;
  function vars(b){if(!b.__v){try{b.__v=JSON.parse(b.querySelector('[data-bundle-variants]').textContent);}catch(e){b.__v=[];}}return b.__v;}
  function find(b,o){return vars(b).find(function(v){return v.o.every(function(x,i){return x===o[i];});});}
  function rowOpts(r){return Array.prototype.map.call(r.querySelectorAll('[data-pick-option]'),function(s){return s.value;});}
  function updRow(b,r){var v=find(b,rowOpts(r));var img=r.querySelector('[data-pick-img]');if(v&&v.i&&img)img.src=v.i;r.classList.toggle('is-out',!v||!v.a);}
  function picksFor(input){var lab=input.closest('.bundle__option');var p=lab&&lab.nextElementSibling;return p&&p.hasAttribute('data-bundle-picks')?p:null;}
  function toggle(b){b.querySelectorAll('.bundle__option input[type="radio"]').forEach(function(inp){var p=picksFor(inp);if(p)p.hidden=!inp.checked;});}
  document.addEventListener('change',function(e){
    var b=e.target.closest('[data-bundle]');
    if(b){
      if(e.target.matches('input[type="radio"]'))toggle(b);
      var r=e.target.closest('[data-bundle-pick]');if(r)updRow(b,r);
      return;
    }
    var picker=e.target.closest('[data-variant-picker]');
    if(picker){
      var s=picker.closest('[data-product-section]');var bb=s&&s.querySelector('[data-bundle]');var idIn=s&&s.querySelector('[data-variant-id]');
      if(!bb||!idIn)return;
      setTimeout(function(){
        var v=vars(bb).find(function(x){return String(x.id)===String(idIn.value);});if(!v)return;
        bb.querySelectorAll('[data-bundle-pick]').forEach(function(r){r.querySelectorAll('[data-pick-option]').forEach(function(sel,i){sel.value=v.o[i];});updRow(bb,r);});
      },0);
    }
  });
  document.addEventListener('submit',async function(e){
    var f=e.target;if(!f.matches||!f.matches('form.product-form'))return;
    var s=f.closest('[data-product-section]');var b=s&&s.querySelector('[data-bundle]');if(!b)return;
    var chk=b.querySelector('.bundle__option input[type="radio"]:checked');if(!chk)return;
    var p=picksFor(chk);if(!p)return;
    e.preventDefault();e.stopImmediatePropagation();
    var btn=f.querySelector('[data-add-to-cart]');var label=btn?btn.textContent:'';
    var counts={},bad=false;
    p.querySelectorAll('[data-bundle-pick]').forEach(function(r){var v=find(b,rowOpts(r));if(!v||!v.a){bad=true;r.classList.add('is-out');return;}counts[v.id]=(counts[v.id]||0)+1;});
    if(bad){if(btn){btn.textContent='Kies een beschikbare variant';setTimeout(function(){btn.textContent=label;},2500);}return;}
    var optLabel=chk.closest('.bundle__option').querySelector('.bundle__text strong');
    var props={_bundle:Date.now().toString(36)+Math.random().toString(36).slice(2,6),_bundle_label:optLabel?optLabel.textContent.trim():''};
    var items=Object.keys(counts).map(function(id){return {id:parseInt(id,10),quantity:counts[id],properties:props};});
    var T=window.theme||{},R=T.routes||{};var drawer=document.getElementById('CartDrawer');var use=T.cartType==='drawer'&&drawer;
    if(btn)btn.classList.add('is-loading');
    try{
      var body={items:items};if(use)body.sections='cart-drawer';
      var res=await fetch((R.cartAdd||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
      var d=await res.json();
      if(!res.ok||d.status){if(btn){btn.textContent=d.description||d.message||'Er ging iets mis';setTimeout(function(){btn.textContent=label;},3000);}return;}
      if(!use){location.href=R.cart||'/cart';return;}
      if(d.sections&&d.sections['cart-drawer']){var doc=new DOMParser().parseFromString(d.sections['cart-drawer'],'text/html');var fr=doc.getElementById('CartDrawer');if(fr)drawer.innerHTML=fr.innerHTML;}
      var c=await (await fetch((R.cart||'/cart')+'.js')).json();
      document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count>0?c.item_count:'';});
      var t=document.createElement('button');t.setAttribute('data-drawer-open','CartDrawer');t.hidden=true;document.body.appendChild(t);t.click();t.remove();
    }catch(err){if(btn){btn.textContent='Er ging iets mis, probeer opnieuw';setTimeout(function(){btn.textContent=label;},3000);}}
    finally{if(btn)btn.classList.remove('is-loading');}
  },true);
})();